import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-card',
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.scss']
})
export class CardComponent implements OnInit {
  @Input() data: any[] = [];
  @Input() rows: any[] = [];
  @Input() expand: boolean = false;

  constructor() {}

  ngOnInit() {}

  getEstilo(item: any) {
    return item.saida === '--' ? 'red' : null;
  }
}
